const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen space-x-2">
      <i className="fa fa-spinner fa-pulse fa-lg text-primary" />
      <h2 className="text-primary text-xl font-medium">Loading</h2>
    </div>
  );
};

export default Loading;
